// import VerifyBtn from '../../../components/verify-btn/VerifyBtn';
// import Geetest from '../../../components/geetest/Geetest';
import { mapGetters } from 'vuex';
import { getterTypes } from '@/store/getter-types';
// import validations from './validations';
// import errorMsgs from './errorMsgs';
// import { getErrorLabelMixin } from '../../../common/mixin/getErrorLabel';
import { reactivateApi } from '@/api/user/reactivateApi';

export default {
  name: 'Reactivation',
//  mixins: [getErrorLabelMixin],
  components: {
    // VerifyBtn,
    // Geetest,
  },
  data() {
    return {
      form_password: {
        password: '',
        repwd: ''
        // gaCode: '',
      },
      form_password_loading: false,
      commitFlag: true,
      showPassword: false,
      showConfirmedPwd: false
      // geetest_email_error: false,
    };
  },
  computed: {
    ...mapGetters([getterTypes.Getter_Lang])
  },
  created() {},
  mounted() {
    this.checkReactivateAcc();
  },
  methods: {
    reactivateAcc() {
      let _that = this;
      // let $form_password = this.$v.form_password;
      // $form_password.$touch();
      // if ($form_password.$error) {
      //   return;
      // }
      let data = {
        key: this.$route.query.key,
        pwd: this.form_password.password
        // gaCode: this.form_password.gaCode
      };
      this._requestActivateAcc(data, _that);
    },
    async _requestActivateAcc(data, _that) {
      _that.form_password_loading = true;
      if (data.key === '') {
        _that.redirectToHome();
      } else {
        reactivateApi
          .reactivateAcc(data)
          .then(() => {
            _that.successNotify(this.$t('success.reactivatePwd'));
            let timer = setTimeout(() => {
              _that.$router.replace('/login');
              clearTimeout(timer);
            }, 1000);
          })
          .catch(error => {
            _that.form_password_loading = false;
            _that.form_password_error = false;
            if (error.errcode === '1106') {
              _that.$router.replace('/login');
            }
          });
      }
    },
    async redirectToHome() {
      await this.$router.push({ name: 'home' });
      window.location.reload(true);
    },
    checkReactivateAcc() {
      let data = {
        data: this.$route.query.key
      };
      reactivateApi
        .checkReactivateAcc(data)
        .then(() => {
          this.commitFlag = false;
        })
        .catch(() => {
          this.redirectToHome();
        });
    }
  }
};
